/**
 * Reproduce un beep corto generado por Web Audio API.
 * No depende de assets. Si el navegador no permite audio sin gesto de usuario,
 * falla silenciosamente — el toast visual se mantiene.
 */
let _ctx = null;
function getCtx() {
  if (_ctx) return _ctx;
  const Ctor = window.AudioContext || window.webkitAudioContext;
  if (!Ctor) return null;
  _ctx = new Ctor();
  return _ctx;
}

export function playKitchenBeep() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    // Algunos navegadores suspenden el contexto hasta interacción de usuario.
    if (ctx.state === "suspended") { ctx.resume().catch(() => {}); }
    const now = ctx.currentTime;
    // 3 tonos cortos ascendentes (A5 → C#6 → E6) — más perceptible en cocinas
    // ruidosas que un solo "ding", sin llegar a ser molesto. Forma de onda
    // "triangle" para timbre más rico que `sine`.
    [
      { f: 880.00, t: now,        d: 0.10 },
      { f: 1108.73, t: now + 0.13, d: 0.10 },
      { f: 1318.51, t: now + 0.26, d: 0.18 },
    ].forEach(({ f, t, d }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "triangle";
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.5, t + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + d);
      osc.connect(gain).connect(ctx.destination);
      osc.start(t);
      osc.stop(t + d + 0.02);
    });
  } catch { /* noop */ }
}
